import axios from '@/store/axios.factory'

class EmissaoGrprService {
  buscarCampos(passo) {
    return axios.post(`/v1/emissao-grpr/buscar-campos`, passo)
  }

  emitir(passo) {
    return axios.post(`/v1/emissao-grpr/emitir`, passo)
  }
  
  consultarInformacoesEmissao(passo) {
    return axios.post(`/v1/emissao-grpr/consultar-informacoes-emissao`, passo)
  }

  validarEmissao(campos) {
    return axios.post(`/v1/emissao-grpr/validar-emissao`, campos)
  }

}

export const emissaoGrprService = new EmissaoGrprService()
